import { render, staticRenderFns } from "./MfImageDialog.vue?vue&type=template&id=9bbbf422&scoped=true&"
import script from "./MfImageDialog.vue?vue&type=script&lang=js&"
export * from "./MfImageDialog.vue?vue&type=script&lang=js&"
import style0 from "./MfImageDialog.vue?vue&type=style&index=0&id=9bbbf422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbbf422",
  null
  
)

export default component.exports